import * as React from 'react';
import { cn } from 'utils/utils';

// Headings
export function H1({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h1 className={cn('font-[DKLiquidEmbrace] text-primary text-[40px] leading-[28px]', className)} {...props} />;
}

export function H2({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn('font-[DKLiquidEmbrace] text-grey800 md:text-[32px] text-[24px]', className)} {...props} />;
}

export function H3({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('font-[LilitaOne] text-[28px] text-primary tracking-[1px]', className)} {...props} />;
}

export function H4({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h4 className={cn('text-[20px] font-[MuseoSansCyrl700] text-primary tracking-[1px]', className)} {...props} />;
}

// Text
export function P({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('font-[MuseoSansCyrl]', className)} {...props} />;
}

export function Label({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      className={cn(
        'w-fit bg-grey100 py-[12px] px-[16px] rounded-[8px] font-[MuseoSansCyrl700] text-[20px] leading-[28px]',
        className
      )}
      {...props}
    />
  );
}
